import { ChangeProfileItemStore, NewProfileItemStore, ProfileItemStore } from './profile-store';

export function setupRepositories(storeBuilder) {
  storeBuilder.addRepository(new ProfileItemStore());
  storeBuilder.addRepository(new NewProfileItemStore());
  storeBuilder.addRepository(new ChangeProfileItemStore());
}
